import { useEffect, useState } from 'react'
import { Card, Grid, TextField, Typography } from '@mui/material'
import api from '../../../../services/api'
import { useSelector } from 'react-redux'
import MessageSuccess from '../../../../messages/messageSuccess'
import ButtonLeft from '../../../../utils/buttonLeft'
import Loading from '../../../../load/loading'
import MessageError from '../../../../messages/messageError'
// import HeaderSession from '../../../../utils/headerSession'
import HeaderGestorConfigs from '../../../../utils/headerGestorConfigs'


const useStyles = () => ({
    root: {
        alignItems: 'end',
    },

    gridItem: {
        padding: 5,
        // background: 'red'
    },
});

export default function GetQuota() {
    const classes = useStyles()
    const [quota, setQuota] = useState('')
    const [quotas, setQuotas] = useState('')
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setErrorMessage] = useState('')
    const [load, setLoad] = useState(false)
    const user = useSelector(state => state.account.user);

    useEffect(() => {
        api.get('/quotas')
            .then(res => {
                // console.log(res)
                setQuotas(res.data.quotas);
            }).catch(err => '')
    }, [messageSuccess])

    function HandleChange(e) {
        setQuota({ ...quota, [e.target.name]: e.target.value })
    }

    async function createQuota() {
        setLoad(true)
        setErrorMessage('')
        setMessageSuccess('')

        await api.post('/quota/create', { ...quota, userId: user?._id })
            .then(res => {
                // console.log(res)
                setLoad(false)
                setMessageSuccess(res.data.msg)

            }).catch(error => {
                // console.log(error)
                setErrorMessage(error.response.data.message)
                setLoad(false)
            })
    }

    return (
        <>

            {/* <HeaderSession
                menu={false}
                title={'GESTÃO DE QUOTAS PARA PRODUTOS CONTROLADOS'}
            /> */}

            <Card style={{ padding: 20, marginBottom: 20, maxWidth: 700 }}>

                {messageSuccess && <MessageSuccess message={messageSuccess} />}
                {messageError && < MessageError message={messageError} />}

                {quotas ?
                    <div style={{ marginBottom: 50 }}>
                        <HeaderGestorConfigs title='QUOTAS ANUAIS PARA PRODUTOS CONTROLADOS:' />
                        {quotas.map((quota) => (
                            <Typography key={quota._id} >
                                <b>#</b> Quota anual:   <b> {quota.quotaAnual} </b>,
                                Quota disponivel:   <b> {quota.quotaDisponivel} </b>,
                                Ano:   <b> {quota.ano} </b>
                            </Typography>
                        ))}
                    </div>
                    :
                    <Loading text={'A carregar quotas'} />
                }

                <Grid container style={classes.root}>

                    <Grid Grid xs={12} md item style={classes.gridItem}>
                        <TextField
                            style={{ marginTop: 15 }}
                            type="number"
                            required
                            label="Quota"
                            fullWidth
                            size="small"
                            name="quota"
                            variant="outlined"
                            onChange={HandleChange}
                            defaultValue={quota?.quota}
                        />
                    </Grid>

                    <Grid xs={12} md item style={classes.gridItem}>
                        <TextField
                            style={{ marginTop: 15 }}
                            type="number"
                            required
                            label="Ano"
                            fullWidth
                            size="small"
                            name="ano"
                            variant="outlined"
                            onChange={HandleChange}
                            defaultValue={quota?.ano}
                        />
                    </Grid>
                </Grid>

                <ButtonLeft
                    title={'Salvar'}
                    load={load}
                    disabled={!quota?.ano}
                    funcao={createQuota}
                />

            </Card>
        </>
    )
}